console.log("IB login script loaded");

let loginTwoFactorId = null;
let isSubmittingToShopify = false;

document.addEventListener("DOMContentLoaded", function () {
  const logInBtn = document.getElementById("logInBtn");
  const errorBox = document.getElementById("ib-login-error");

  const mfaModal = document.getElementById("ib-mfa-modal");
  const mfaInput = document.getElementById("ib-mfa-code");
  const verifyMfaBtn = document.getElementById("ib-verify-mfa");
  const closeMfaBtn = document.getElementById("ib-close-mfa");

  const loginForm = document.getElementById("customer_login");
  const returnToInput = document.getElementById("CustomerLogin-return-to");
  const createAccountLink = document.getElementById("CustomerLogin-create-account-link");

  if (!loginForm) return;

  /* ---------------- IFRAME PROTECTION ---------------- */

  if (window.top !== window.self) {
    window.top.location = window.location.href;
    return;
  }

  /* ---------------- REDIRECT HELPERS ---------------- */

  function getSafeReturnTo() {
    const params = new URLSearchParams(window.location.search);
    const returnTo = params.get("return_to");

    /*
      Only allow internal relative paths:
      ✅ /nl/pages/recipe/example
      ✅ /account
      ❌ https://evil.com
      ❌ //evil.com
      ❌ javascript:alert(1)
    */
    if (returnTo && returnTo.startsWith("/") && !returnTo.startsWith("//")) {
      return returnTo;
    }

function fixAccountUrl(url) {
  if (!url) return "";

  return url
    // Fix /nlaccount, /deaccount, /fraccount, /pt-ptaccount etc.
    .replace(/^\/([a-z]{2}(?:-[a-z]{2})?)account$/i, "/$1/account")
    // Fix /nlcustomers, indien relevant
    .replace(/^\/([a-z]{2}(?:-[a-z]{2})?)customers/i, "/$1/customers");
}

function getLocalizedAccountUrl() {
  const root = window.Shopify?.routes?.root || "/";

  return `${root.endsWith("/") ? root : root + "/"}account`;
}

return fixAccountUrl(returnToInput?.value) || getLocalizedAccountUrl();
  }

  function setReturnToInput() {
    if (!returnToInput) return;

    returnToInput.value = getSafeReturnTo();
  }

  function updateCreateAccountLink() {
    if (!createAccountLink) return;

    const safeReturnTo = getSafeReturnTo();
    const url = new URL(createAccountLink.href, window.location.origin);

    url.searchParams.set("return_to", safeReturnTo);

    createAccountLink.href = url.pathname + url.search;
  }

  setReturnToInput();
  updateCreateAccountLink();

  /* ---------------- UI HELPERS ---------------- */

  function showError(message) {
    if (!errorBox) return;

    errorBox.innerText = message;
    errorBox.style.display = "block";
  }

  function clearError() {
    if (!errorBox) return;

    errorBox.innerText = "";
    errorBox.style.display = "none";
  }

  function showToast(message, type = "success") {
    const toast = document.getElementById("ib-toast");
    if (!toast) return;

    toast.innerText = message;
    toast.style.background = type === "success" ? "#2ecc71" : "#e74c3c";
    toast.style.display = "block";

    setTimeout(function () {
      toast.style.opacity = "1";
    }, 10);

    setTimeout(function () {
      toast.style.opacity = "0";

      setTimeout(function () {
        toast.style.display = "none";
      }, 300);
    }, 2500);
  }

  /* ---------------- COOKIE MANAGEMENT ---------------- */

  function deleteTokenCookie() {
    document.cookie =
      "token=; Path=/; Domain=.innerbuddies.com; Expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=None";
  }

  /* ---------------- MFA UI ---------------- */

  function showMFAModal() {
    if (!mfaModal) return;

    mfaModal.style.display = "flex";

    if (mfaInput) {
      mfaInput.focus();
    }
  }

  function hideMFAModal() {
    if (mfaModal) {
      mfaModal.style.display = "none";
    }

    if (mfaInput) {
      mfaInput.value = "";
    }

    loginTwoFactorId = null;
  }

  /* ---------------- TOKEN SAVE ---------------- */

  function finishLogin(token) {
    if (!token) return;

    deleteTokenCookie();

    localStorage.setItem("token", token);

    const d = new Date();
    d.setTime(d.getTime() + 8 * 24 * 60 * 60 * 1000);

    document.cookie =
      "token=" +
      encodeURIComponent(token) +
      "; Path=/; Domain=.innerbuddies.com; Expires=" +
      d.toUTCString() +
      "; Secure; SameSite=None";

    hideMFAModal();
  }

  /* ---------------- SHOPIFY SUBMIT ---------------- */

  function submitShopifyLogin() {
    setReturnToInput();

    sessionStorage.setItem("ibLoginSuccess", "true");

    isSubmittingToShopify = true;
    loginForm.submit();
  }

  /* ---------------- MAIN LOGIN ---------------- */

  async function processForm(e) {
    if (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }

    if (isSubmittingToShopify) return;

    sessionStorage.removeItem("ibLoginSuccess");
    clearError();
    setReturnToInput();

    const formData = new FormData(loginForm);

    const email = formData.get("customer[email]");
    const password = formData.get("customer[password]");

    if (!email || !password) {
      showError("Please enter both email and password.");
      return;
    }

    try {
      if (logInBtn) {
        logInBtn.disabled = true;
      }

      const response = await fetch(
        "https://microbiome-api-mjmpwq5lsa-ez.a.run.app/api/v1/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "accept": "application/json"
          },
          body: JSON.stringify({
            email: String(email).toLowerCase(),
            password: password,
            design: "default"
          })
        }
      );

      const isJson = response.headers
        .get("content-type")
        ?.includes("application/json");

      const data = isJson ? await response.json() : null;

      /*
        If IB API login fails, still submit to Shopify.
        This keeps Shopify as fallback source of truth.
      */
      if (!response.ok && response.status !== 242) {
        submitShopifyLogin();
        return;
      }

      /*
        MFA required
      */
      if (response.status === 242) {
        loginTwoFactorId = data?.twoFactorId || null;

        if (!loginTwoFactorId) {
          showToast("2FA login failed", "error");

          if (logInBtn) {
            logInBtn.disabled = false;
          }

          return;
        }

        showMFAModal();
        showToast("Enter your 2FA code", "error");

        if (logInBtn) {
          logInBtn.disabled = false;
        }

        return;
      }

      /*
        IB API login success
      */
      if (data?.access_token) {
        finishLogin(data.access_token);
      }

      submitShopifyLogin();
    } catch (err) {
      console.error(err);

      /*
        On network/API error, fall back to Shopify login.
        Do not block the user if Shopify credentials are valid.
      */
      submitShopifyLogin();
    }
  }

  /* ---------------- MFA VERIFY ---------------- */

  async function verifyMFA() {
    if (!mfaInput?.value || !loginTwoFactorId) {
      showToast("Invalid 2FA code", "error");
      return;
    }

    try {
      if (verifyMfaBtn) {
        verifyMfaBtn.disabled = true;
      }

      const response = await fetch(
        "https://microbiome-api-mjmpwq5lsa-ez.a.run.app/api/v1/login/mfa",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "accept": "application/json"
          },
          body: JSON.stringify({
            two_factor_id: loginTwoFactorId,
            code: mfaInput.value.trim().toUpperCase(),
            design: "default"
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        showToast("2FA verification failed", "error");

        if (verifyMfaBtn) {
          verifyMfaBtn.disabled = false;
        }

        return;
      }

      if (!data?.access_token) {
        showToast("Login failed", "error");

        if (verifyMfaBtn) {
          verifyMfaBtn.disabled = false;
        }

        return;
      }

      finishLogin(data.access_token);
      submitShopifyLogin();
    } catch (err) {
      console.error(err);
      showToast("Something went wrong", "error");

      if (verifyMfaBtn) {
        verifyMfaBtn.disabled = false;
      }
    }
  }

  /* ---------------- SHOPIFY FAILURE DETECTION ---------------- */

  const shopifyError =
    document.querySelector(".form__message") ||
    document.querySelector(".errors") ||
    document.querySelector(".form-message");

  const ibLoginSucceeded =
    sessionStorage.getItem("ibLoginSuccess") === "true";

  if (shopifyError && ibLoginSucceeded) {
    console.log("Shopify failed + IB succeeded → redirecting to portal");

    sessionStorage.removeItem("ibLoginSuccess");

    window.location.href = "https://portal.innerbuddies.com";
    return;
  }

  /* ---------------- EVENTS ---------------- */

  if (logInBtn) {
    logInBtn.addEventListener("click", processForm);
  }

  if (loginForm) {
    loginForm.addEventListener("submit", processForm);
  }

  if (verifyMfaBtn) {
    verifyMfaBtn.addEventListener("click", verifyMFA);
  }

  if (closeMfaBtn) {
    closeMfaBtn.addEventListener("click", hideMFAModal);
  }

  if (mfaInput) {
    mfaInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        verifyMFA();
      }
    });
  }
});